import { CheckCircle, Error, Info, Warning } from "@mui/icons-material";
import {
  Box,
  Button,
  darken,
  Modal,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import useStyles from "./styles";
import CheckIcon from "@mui/icons-material/Check";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";

export default function InternoModalConfirmacaoSaida(params) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const {
    openConfirmacao = false,
    setOpenConfirmacao = () => {},
    confirmLoad = false,
    execute = () => {},
    cancel = () => {},
    severity = "",
    contentText = "",
    confirmText = "",
    headerText = "",
    title = "",
    children = null,
    confirmDisabled = false,
    paperSx = null,
    paperInternoSx = null,
    hideCancel = false,
  } = params;

  return (
    <Modal
      open={openConfirmacao}
      onClose={() => {
        cancel();
        setOpenConfirmacao(false);
      }}
      sx={styles.modal}
    >
      <Box sx={{ position: "relative" }}>
        <Paper sx={{ ...styles.paper, ...(paperSx || {}) }}>
          <Paper
            elevation={0}
            sx={{ ...styles.paperInterno, ...(paperInternoSx || {}) }}
          >
            <Box sx={styles.header}>
              {theme.palette.mode === "light" && (
                <Box sx={styles.circleWhiteMode} />
              )}

              <Box
                sx={{
                  ...styles.circleTransparent,
                  bgcolor: `${
                    severity === "warning"
                      ? theme.palette.colors.orange.medium
                      : severity === "info"
                        ? theme.palette.colors.blue.light
                        : severity === "success"
                          ? theme.palette.colors.green.light
                          : theme.palette.colors.red.medium
                  }6b`,
                }}
              >
                <Box
                  sx={{
                    ...styles.circleFixed,
                    bgcolor:
                      severity === "warning"
                        ? theme.palette.colors.orange.medium
                        : severity === "info"
                          ? theme.palette.colors.blue.light
                          : severity === "success"
                            ? theme.palette.colors.green.light
                            : theme.palette.colors.red.medium,
                  }}
                >
                  {severity === "warning" ? ( //
                    <Typography sx={styles.typographyIcon}>!</Typography>
                  ) : severity === "info" ? (
                    <Typography sx={styles.typographyIcon}>i</Typography>
                  ) : severity === "success" ? (
                    <CheckIcon sx={styles.typographyIcon} />
                  ) : (
                    <ReportProblemOutlinedIcon sx={styles.errorIcon} />
                  )}
                </Box>
              </Box>

              <Typography variant="myTitle" sx={styles.title}>
                {title}
              </Typography>
            </Box>
            <Box sx={styles.boxTextContent}>
              <Typography sx={styles.typographyText}>{headerText}</Typography>
              <Typography sx={styles.typographyText}>{contentText}</Typography>
              {children}
            </Box>
            <Box sx={styles.boxButtons}>
              {!hideCancel && (
                <Button
                  variant="outlined"
                  onClick={() => {
                    setOpenConfirmacao(false);
                    cancel();
                  }}
                  sx={{ borderRadius: "10px" }}
                >
                  Cancelar
                </Button>
              )}

              <Button
                onClick={execute}
                disabled={confirmLoad || confirmDisabled}
                variant="contained"
                sx={{
                  borderRadius: "10px",
                  bgcolor:
                    severity === "warning"
                      ? theme.palette.colors.orange.medium
                      : severity === "info"
                        ? theme.palette.colors.blue.light
                        : severity === "success"
                          ? theme.palette.colors.green.light
                          : theme.palette.colors.red.medium,
                  color: theme.palette.white.main,
                  "&:hover": {
                    bgcolor:
                      severity === "warning"
                        ? darken(theme.palette.colors.orange.medium, 0.2)
                        : severity === "info"
                          ? darken(theme.palette.colors.blue.light, 0.2)
                          : severity === "success"
                            ? darken(theme.palette.colors.green.light, 0.2)
                            : darken(theme.palette.colors.red.medium, 0.2),
                  },
                }}
              >
                {confirmText ? confirmText : "Confirmar"}
              </Button>
            </Box>
          </Paper>
        </Paper>
      </Box>
    </Modal>
  );
}
